import React from "react";

import MuiFormControl from "@material-ui/core/FormControl";
import MuiFormHelperText from "@material-ui/core/FormHelperText";
import MuiInputLabel from "@material-ui/core/InputLabel";
import MuiMenuItem from "@material-ui/core/MenuItem";
import MuiSelect from "@material-ui/core/Select";

const Select = ({
  field,
  form: { handleChange, handleBlur },
  options,
  label,
  className,
  fullWidth,
  helperText,
  error,
  ...props
}) => (
  <MuiFormControl fullWidth={fullWidth} className={className}>
    <MuiInputLabel htmlFor={field.name}>{label}</MuiInputLabel>
    <MuiSelect
      inputProps={{
        name: field.name,
        id: field.name
      }}
      value={field.value}
      onChange={handleChange}
      onBlur={handleBlur}
      {...props}
    >
      {!!options &&
        options.length > 0 &&
        options.map(({ value, label }) => {
          return (
            <MuiMenuItem key={value} value={value}>
              {label}
            </MuiMenuItem>
          );
        })}
    </MuiSelect>
    <MuiFormHelperText error>{helperText}</MuiFormHelperText>
  </MuiFormControl>
);

export default Select;
